import { z } from 'zod';
import { OperationIdSchema } from '../../ids';
import { CampIdSchema, CampViewSchema } from '../../models/camp';
import { InventorySchema } from '../../models/inventory';
import { QuantitySchema } from '../../models/items';
import { TimestampMsSchema } from '../../time';
import { API_PREFIX, defineEndpoint } from '../endpoint';

const params = z.object({ campId: CampIdSchema });
const body = z.object({ operationId: OperationIdSchema });

/** The camp settled now (PrimeraVersion.md §13: panel with ownership, load, defense, repair). */
export const getCamp = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/camps/:campId`,
  access: 'session',
  params,
  response: z.object({ serverTime: TimestampMsSchema, camp: CampViewSchema }),
});

/**
 * Claims a free camp, paying `claimCost` from the claimer's town storage. The character must
 * stand by the camp. Idempotent by operation id.
 */
export const claimCamp = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/camps/:campId/claim`,
  access: 'session',
  params,
  body,
  response: z.object({
    operationId: OperationIdSchema,
    camp: CampViewSchema,
    inventory: InventorySchema,
  }),
});

/** The owner, standing by the camp, moves its stock into the backpack (as much as fits). */
export const withdrawCamp = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/camps/:campId/withdraw`,
  access: 'session',
  params,
  body,
  response: z.object({
    operationId: OperationIdSchema,
    withdrawn: QuantitySchema,
    camp: CampViewSchema,
    inventory: InventorySchema,
  }),
});

/** The owner, standing by the damaged camp, repairs it paying `repairCost` from the storage. */
export const repairCamp = defineEndpoint({
  method: 'POST',
  path: `${API_PREFIX}/camps/:campId/repair`,
  access: 'session',
  params,
  body,
  response: z.object({
    operationId: OperationIdSchema,
    camp: CampViewSchema,
    inventory: InventorySchema,
  }),
});
